define('controller/template/template.detail.controller',['require','exports','module','underscore','backbone','fukit','view/template/template.detail.page.view','fukit','formkit/formkit','model/template.model','model/template.type.template.object.type.model','model/revision.model','backbone.radio','view/template/confirmation.modal','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _                                   = require('underscore'),
      Backbone                            = require('backbone'),
      BaseController                      = require('fukit').BaseController,
      TemplateDetailPageView              = require('view/template/template.detail.page.view'),
      RouteHelper                         = require('fukit').RouteHelper,
      FormKit                             = require('formkit/formkit'),
      TemplateMetaModel                   = require('model/template.model'),
      TemplateTypeTemplateObjectTypeModel = require('model/template.type.template.object.type.model'),
      Revision                            = require('model/revision.model'),
      Radio                               = require('backbone.radio'),
      ConfirmationModal                   = require('view/template/confirmation.modal'),
      ROLES                               = require('fukit').Roles;

  var TemplateDetailController = BaseController.extend({
    radioRequests: {
      'controllers TemplateDetailController': '@constructor',
    },

    pageView: TemplateDetailPageView,

    pageViewOptions: function() {
      return {
        form: this.createForm(),
      };
    },

    stateConfiguration: {
      defaults: {
        roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
      },
    },

    resources: {
      revision: {
        model: Revision,
      },
      template: {
        model: FormKit.TemplateModel,
      },
      templateObjectTypes: {
        collection: Backbone.Collection.extend({
          comparator: 'description',
        }),
      },
      templateTypeTemplateObjectType: {
        collection: TemplateTypeTemplateObjectTypeModel.Collection,
      },
      templateMeta: {
        model: TemplateMetaModel,
        require: true,
        attrs: {
          id: '@state.primaryId',
        },
      },
      revisions: {
        collection: Revision.Collection,
      },
      revisionsHistory: {
        collection: Revision.Collection,
      },
    },

    fallbackFragment: function() {
      return RouteHelper.resolve('template:list');
    },

    initialize: function() {
      BaseController.prototype.initialize.apply(this, arguments);

      var revisionCollection = this.getResource('revisions');
      var revisionHistoryCollection = this.getResource('revisionsHistory');

      revisionHistoryCollection.paginate.size(0);
      revisionHistoryCollection.sort.field('publishedDate').makeDescending();

      revisionHistoryCollection.filters.add({ field: 'template.id', value: this.state.get('primaryId') });

      revisionHistoryCollection.filters.add({ field: 'publishedDate' }).notNull();

      revisionCollection.paginate.size(1);
      revisionCollection.sort.field('createDate').makeDescending();
      revisionCollection.filters.add({
        field: 'template.id',
        value: this.state.get('primaryId'),
      });

      revisionCollection.filters.add({ field: 'publishedDate' }).isNull();

      revisionCollection.once(
        'sync',
        function(revisionCollection, resp, options) {
          if (revisionCollection.length == 0) {
            return;
          }
          var revisionModel = this.getResource('revision');
          var templateModel = this.getResource('template');

          revisionModel.set(revisionCollection.first().attributes);

          this.state.set('revisionId', revisionModel.id);
          templateModel.set(revisionModel.get('json'));
          templateModel.trigger('sync', templateModel, options);
          revisionModel.trigger('sync', revisionModel, resp, options);

          this.listenTo(revisionCollection, 'sync', function() {
            revisionCollection.resetUnsavedChanges();
          });

          this.listenTo(this.getResource('revision'), 'sync', function() {
            templateModel.set(revisionModel.get('json'));
            templateModel.trigger('sync', templateModel, options);
            revisionModel.resetUnsavedChanges();
          });
        },
        this
      );

      this.listenTo(this.getResource('revision'), 'error', function(revisionModel, error) {
        var xhr = _.result(error, 'xhr');
        var status = _.result(xhr, 'status');
        if (status == 423) {
          // re-fetch the revision if the status is 423 (locked!)
          revisionModel.fetch({ persistError: true });
        }
      });

      // Setup events
      this.listenTo(this.getResource('templateMeta'), 'sync', this.onTemplateMetaResourceSync);
      this.listenTo(
        this.getResource('templateTypeTemplateObjectType'),
        'sync',
        this.onTemplateTypeTemplateObjectTypeResourceSync
      );
    },

    /**
     * Specify the page constructor for the form editor mixin
     */

    onStart: function() {
      // If existing template
      if (!this.getResource('templateMeta').isNew()) {
        // Fetch templateMetaModel and revisionCollection
        this.getResource('templateMeta').fetch();

        this.fetchResource('revisions');
      }
    },

    onTemplateMetaResourceSync: function() {
      var templateTypeId = this.getResource('templateMeta').get('templateType').id,
        templateTypeTemplateObjectTypeCollection = this.getResource('templateTypeTemplateObjectType'),
        filters = templateTypeTemplateObjectTypeCollection.filters;

      filters.add({ field: 'templateType.id', value: templateTypeId });

      templateTypeTemplateObjectTypeCollection.fetch();
    },

    onTemplateTypeTemplateObjectTypeResourceSync: function() {
      var templateTypeTemplateObjectTypeCollection = this.getResource('templateTypeTemplateObjectType'),
        templateObjectTypeCollection = this.getResource('templateObjectTypes');

      _.each(templateTypeTemplateObjectTypeCollection.models, function(templateTypeTemplateObjectTypeModel) {
        var templateObjectTypeModel = templateTypeTemplateObjectTypeModel.get('templateObjectType');
        var maxMultiplicity = templateTypeTemplateObjectTypeModel.get('maxMultiplicity');

        templateObjectTypeModel.set('maxMultiplicity', maxMultiplicity);
      });

      templateObjectTypeCollection.set(templateTypeTemplateObjectTypeCollection.pluck('templateObjectType'));
      templateObjectTypeCollection.trigger('sync', templateObjectTypeCollection, {});
    },

    createForm: function() {
      var form = new FormKit.Form({
        templateModel: this.getResource('template'),
        templateObjectTypeCollection: this.getResource('templateObjectTypes'),
        confirmationModal: ConfirmationModal,
      });

      this.listenTo(form, 'modify:template', function() {
        this.getResource('revision').set('json', form.getTemplateModel().toJSON());
      });

      return form;
    },
  });

  module.exports = TemplateDetailController;
});

